// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CAT_FOOTWEAR = "Obuv";
export const BZ2_CAT_PRAMS = "Ko\u010d\u00e1rky";
export const BZ2_CAT_TOYS = "Hra\u010dky a hry";
export const HOME_SHOW_PRODUCTS_FROM_location = "Inzer\u00e1ty v %(location)s";
